import { useEffect, useRef, useState } from "react";
import { fmt } from "@/lib/savings";

const reducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const useTween = (target, duration = 320) => {
  const [value, setValue] = useState(target);
  const from = useRef(target);

  useEffect(() => {
    if (reducedMotion()) { from.current = target; setValue(target); return undefined; }
    const start = performance.now();
    const origin = from.current;
    let raf = 0;
    const step = (now) => {
      const p = Math.max(0, Math.min(1, (now - start) / duration));
      const v = origin + (target - origin) * (1 - Math.pow(1 - p, 3));
      from.current = v;
      setValue(v);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return value;
};

export const AnimatedNumber = ({ value, prefix = "" }) => <>{prefix}{fmt(useTween(value))}</>;
